export default __webpack_public_path__ + "static/media/power1.750c1925.svg";